'use client';

export { default as Alert } from './Alert/index.js';
export { default as Button } from './Button/index.js';
export { default as CheckBox } from './CheckBox/index.js';
export { default as Dialog } from './Dialog/index.js';
export { TextareaForm } from './FormComponent/index.js';
export { FMForm, FormManager, useFMFormContext } from './FormManager/index.js';
export { default as FMCheckBox } from './FormManager/CheckBox/index.js';
export { default as FMCompanySelect } from './FormManager/CompanySelect/index.js';
export { DatePickerInput, default as FMDatePicker } from './FormManager/DatePicker/index.js';
export { default as FMI11lPhoneNumberInput } from './FormManager/I11lPhoneNumberInput/index.js';
export { default as FMInput } from './FormManager/Input/index.js';
export { default as FMInputYOE } from './FormManager/InputYOE/index.js';
export { default as FMSelect } from './FormManager/Select/index.js';
export { default as FMTextEditor } from './FormManager/TextEditor/index.js';
export { default as FormModal } from './FormModal/index.js';
export { default as FormView } from './FormView/index.js';
export { default as Input } from './Input/index.js';
export { default as JobAlertBar } from './JobAlertBar/index.js';
export { default as JobItem } from './JobItem/index.js';
export { default as MobileFullScreenList } from './MobileFullScreenList/index.js';
export { default as MobileSelect } from './MobileSelect/index.js';
export { default as MobileSort } from './MobileSort/index.js';
export { default as Modal } from './Modal/index.js';
export { default as SlideModal } from './Modal/SlideModal.js';
export { default as MultiTagSelect } from './MultiTagSelect/index.js';
export { default as MultiTagSelectV2 } from './MultiTagSelectV2/index.js';
export { default as NoResult } from './NoResult/index.js';
export { default as PopupNewUser } from './PopupNewUser/index.js';
export { default as Proficiency } from './Proficiency/index.js';
export { default as Radio } from './Radio/index.js';
export { default as ReportJobModal } from './ReportJobModal/index.js';
export { default as ReportCompanyModal } from './ReportCompanyModal/index.js';
export { default as HRInsider } from './HRInsider/index.js';
export { default as Select } from './Select/index.js';
export { default as SelectedTag } from './SelectedTag/index.js';
export { default as Skeleton } from './Skeleton/index.js';
export { default as SocialShare } from './SocialShare/index.js';
export { SelectOptionType, default as TagSelect } from './TagSelect/index.js';
export { default as TextEditor } from './TextEditor/index.js';
export { default as textEditorUtils } from './TextEditor/textEditorUtils.js';
export { default as Textarea } from './Textarea/index.js';
export { default as Toast } from './Toast/index.js';
export { default as Tooltip } from './Tooltip/index.js';
export { default as UploadResumeModal } from './UploadResumeModal/index.js';
export { ENestedDatasetName, MobileSelectMode } from './types/index.js';
export { default as BarChart } from './BarChart/index.js';
export { default as BottomSheet } from './BottomSheet/index.js';
export { default as ButtonPrimary } from './ButtonPrimary/index.js';
export { OptionGroup } from './OptionGroup/index.js';
export { OptionGroupStyled } from './OptionGroup/OptionGroup.style.js';
export { default as Chart } from './Chart/index.js';
export { default as Chip } from './Chip/index.js';
export { default as CircleProgressBar } from './CircleProgressBar/index.js';
export { default as Collapse } from './Collapse/index.js';
export { default as CompaniesYouWillLove } from './CompaniesYouWillLove/index.js';
export { default as CompanyCard } from './CompanyCard/index.js';
export { default as CompanyInfo } from './CompanyInfo/index.js';
export { default as CompanySelect } from './CompanySelect/index.js';
export { default as EmptyResult } from './EmptyResult/index.js';
export { default as I11lPhoneNumberInput } from './I11lPhoneNumberInput/index.js';
export { default as InputYOE } from './InputYOE/index.js';
export { default as JobAlert } from './JobAlert/index.js';
export { default as JobYouWillLove } from './JobYouWillLove/index.js';
export { default as Col } from './LayoutSystem/Col.js';
export { default as Row } from './LayoutSystem/Row.js';
export { BREAKPOINTS } from './LayoutSystem/constants.js';
export { default as LinkedIn } from './LinkedIn/index.js';
export { default as MultipleRadio } from './MultipleRadio/index.js';
export { default as MultipleSelect } from './MultipleSelect/index.js';
export { default as PieChart } from './PieChart/index.js';
export { default as Podcast } from './Podcast/index.js';
export { default as PopoverWhatNew } from './PopoverWhatNew/index.js';
export { default as Popup } from './Popup/index.js';
export { default as PreviewJob } from './PreviewJob/index.js';
export { default as ProgressBar } from './ProgressBar/index.js';
export { default as QuickApplyJobModal } from './QuickApplyJobModal/index.js';
export { default as RecommendJobs } from './RecommendJobs/index.js';
export { getLastViewJobId } from './RecommendJobs/helper.js';
export { getRecommendJobs } from './RecommendJobs/services.js';
export { default as Icons } from './Referral/CreateCandidateModal/images.js';
export { default as SearchBarUnstable } from './SearchBarUnstable/index.js';
export { default as SettingJob } from './SettingJob/index.js';
export { default as ShareButton } from './ShareButton/index.js';
export { default as SimpleTooltip } from './SimpleTooltip/index.js';
export { default as SingleCheckBox } from './SingleCheckBox/index.js';
export { default as SingleRadio } from './SingleRadio/index.js';
export { default as SlideShow } from './SlideShow/index.js';
export { default as Slider } from './Slider/index.js';
export { default as Switcher } from './Switcher/index.js';
export { default as Tabs } from './Tabs/index.js';
export { default as Tag } from './Tag/index.js';
export { default as TagBasic } from './TagBasic/index.js';
export { default as TextEditorQuill } from './TextEditorQuill/index.js';
export { default as TravelLine } from './TravelLine/index.js';
export { default as TreeSelect } from './TreeSelect/index.js';
export { default as TrustedCompanyName } from './TrustedCompanyName/index.js';
import { colors } from './Utils/constants.js';
export { EAppMode, ELanguage, SEARCH_PARAMS } from './Utils/constants.js';
export { default as StyledCss } from './Utils/styledCss.js';
export { callTrackingUTM, formatCanonicalUrl } from './Utils/utmTracking.js';
export { default as YourResumeScore } from './YourResumeScore/index.js';
export { default as ZaloWidget } from './ZaloWidget/index.js';
export { NavIcons } from './icons/index.js';
export { default as JobCard } from './JobCard/index.js';
export { default as JobCardList } from './JobCardList/index.js';
export { default as JobCardMini } from './JobCardMini/index.js';
export { default as JobCardMiniList } from './JobCardMiniList/index.js';
export { default as LoginModal } from './LoginModal/index.js';
export { default as UploadFile } from './UploadFile/index.js';
export { default as CompanyIndustry } from './CompanyIndustry/index.js';
export { default as AspectRatio } from './AspectRatio/index.js';
export { default as ApplyJobsForm } from './ApplyJobsForm/index.js';
export { default as Calendar } from './Calendar/index.js';
export { default as DatePicker } from './DatePicker/components/DatePicker.js';
export { default as RangePicker } from './DatePicker/components/RangePicker.js';
export { default as CombinePicker } from './DatePicker/components/CombinePicker.js';
export { EDatePicker } from './DatePicker/type.js';
export { default as PopupWarning } from './PopupWarning/index.js';
export { default as Form } from './Form/index.js';
export { default as Typography } from './Typography/index.js';
export { Anchor, H1, H2, H3, H4, H5, H6, Label, Paragraph, Span } from './Typography/components/Variant.js';
export { colors } from './Colors/index.js';
export { default as DragDropResumeUpload } from './DragDropResumeUpload/index.js';
export { default as Avatar } from './Avatar/index.js';
export { TranslateContext, useTranslate } from './Contexts/translator/index.js';
export { default as ButtonViewMore } from './ButtonViewMore/index.js';
export { default as ForceLogOut } from './ForceLogOut/index.js';
export { default as JobFunction } from './JobFunction/index.js';
export { default as PopupCVReplace } from './PopupCVReplace/index.js';
export { OnBoarding } from './OnBoarding/ index.js';
export { default as QuestionMarkIcon } from './icons/QuestionMarkIcon.js';
export { XaloLead } from './XaloLead/index.js';
export { default as Accordion } from './Accordion/index.js';
export { EBoxType } from './DragDropResumeUpload/type.js';
export { default as CompanyCardSquare } from './CompanyCardSquare/index.js';
export { default as Container } from './Container/index.js';
export { default as AdrTurboBanner } from './AdrTurboBanner/index.js';
export { default as ApplyJobsModal } from './ApplyJobsModal/index.js';
export { default as ApplyJobs } from './ApplyJobs/index.js';
export { default as Cascader } from './Cascader/index.js';
export { default as TikTok } from './SocialEmbed/TikTok/index.js';
export { default as JobMatchingAnalysis } from './JobMatchingAnalysis/index.js';
export { default as MailBoxJobAlert } from './PopupCreateJobAlertUMD/PopupUMD.js';
export { default as CustomRadio } from './CustomRadio/index.js';
export { convertDateToISO, dateToString } from './Utils/time.js';
export { default as HogProvider } from './PostHog/HogProvider/index.js';
export { default as useIdentify } from './PostHog/hooks/useIdentify/index.js';
export { default as useHog } from './PostHog/hooks/useHog/index.js';
import * as index from './Utils/index.js';
export { index as Utils };
import * as index$3 from './services/index.js';
export { index$3 as Services };
import * as index$1 from './Images/index.js';
export { index$1 as Images };
import * as index$2 from './hooks/index.js';
export { index$2 as Hooks };
export { default as TextField } from './TextField/index.js';
export { default as AutoComplete } from './AutoComplete/index.js';
export { default as NTag } from './NTag/index.js';
export { default as Skills } from './Skills/index.js';
export { default as MultiLevelSelect } from './MultiLevelSelect/MultiLevelSelect/index.js';
import './MultiLevelSelect/MultiLevelCore/index.js';
import './_virtual/_tslib.js';
import 'react';
import './MultiLevelSelect/store.js';
import './MultiLevelSelect/MultiLevelDropdown/styles.js';
import './MultiLevelSelect/MultiLevelPopup/styles.js';
export { default as JobPostCard } from './JobPostCard/index.js';
export { default as LazyloadCSR } from './LazyloadCSR/index.js';
export { default as AIReviewCV } from './AIReviewCV/index.js';
export { default as ButtonAI } from './ButtonAI/index.js';
export { default as AICircleProgressBar } from './AICircleProgressBar/index.js';
export { default as AttachName } from './AttachName/index.js';
export { default as Notifications, openNotification } from './Notifications/index.js';
export { default as Pagination } from './Pagination/index.js';
export { default as AIBanner } from './AIBanner/index.js';
export { default as AIBeforeApply } from './AIBeforeApply/index.js';
export { default as ContentEditable } from './FormComponent/ContentEditable/index.js';
export { ECalendarStyle, ECalendarType } from './Calendar/types.js';
export { translator } from './Contexts/translator/helper.js';

/**
 * Don't import ReferralButton here regarding it cause "document is not defined" issue on NextJS projects.
 * e.g. microfrontends/referral-candidate
 *
 * @author Tuan, Phan Thanh
 * @since 27 Jul, 2022
 */
var Colors = {
    text: colors.textColor,
    textPlaceholder: colors.textPlaceholder,
    textGray: colors.textGrayColor,
    primary: colors.primaryColor,
    secondary: colors.secondaryColor,
    button: colors.buttonColor,
    info: colors.infoColor,
    success: colors.successColor,
    danger: colors.dangerColor,
    highlight: colors.highlightColor,
    darkBlue: colors.darkBlueColor,
    bgNormal: colors.bgNormal,
    bgHover: colors.bgHover,
    bgError: colors.bgError,
    bgDisable: colors.bgDisable,
    bgHeader: colors.bgHeader,
    borderNormal: colors.borderNormal,
    borderHover: colors.borderHover,
    borderFocus: colors.borderFocus,
    borderError: colors.borderError,
    borderDisable: colors.borderDisable,
    borderCard: colors.borderCard,
    cardShadow: colors.cardShadow,
    tagSelect: colors.tagSelect,
    tagSelectBorder: colors.tagSelectBorder,
    tagHover: colors.tagHover
};

export { Colors };
//# sourceMappingURL=index.js.map
